import React, { useEffect, useState } from 'react';
import AllSocialMediaFilters from './AllSocialMediaFilters';
import FiltersContainer from './FiltersContainer';
import * as R from 'ramda';
import useFiltersInitialState from '@app/allSocialMediaPosts/hooks/useFiltersInitialState';
import { getFilterTagsDataFromFilters } from '../utils/filters';
import {
    getAccountOptionsFromResponse,
    getFilteredOnoAccounts,
    getPlatformAccountMap,
} from '../utils';
import { fetchAuthorizedAccounts } from '@app/allSocialMediaPosts/api/authorizedAccounts';
import { fetchRightsholdersWithOnoAccounts } from '@app/allSocialMediaPosts/api/rightsholdersWithOnoAccounts';

type AuthenticatedPostsFiltersProps = {
    clientId: number;
    isDataLoading: boolean;
    // eslint-disable-next-line no-unused-vars
    onFilterPosts: (params: any) => void;
    postsCampaigns: Record<number, { label: string; value: number }>;
    currentTab: string;
};

const AuthenticatedPostsFilters = ({
    clientId,
    isDataLoading,
    onFilterPosts,
    postsCampaigns,
    currentTab,
}: AuthenticatedPostsFiltersProps) => {
    const initialFilters = useFiltersInitialState();
    const [filters, setFilters] = useState(initialFilters);
    const [platformAccountsMap, setPlatformAccountsMap] = useState({});
    const [accountOptions, setAccountOptions] = useState({});
    const [filterTagsData, setFilterTagsData] = useState(
        getFilterTagsDataFromFilters(filters),
    );

    const handleFiltersUpdate = () => {
        setFilterTagsData(getFilterTagsDataFromFilters(filters));
        onFilterPosts(filters);
    };

    useEffect(() => {
        (async () => {
            const authorizedAccounts = await fetchAuthorizedAccounts(clientId);

            const onoAccounts =
                await fetchRightsholdersWithOnoAccounts(clientId);
            const filteredOnoAccounts = getFilteredOnoAccounts(onoAccounts);

            const accountsMap = R.mergeAll([
                getPlatformAccountMap(authorizedAccounts),
                getPlatformAccountMap(filteredOnoAccounts),
            ]);
            setPlatformAccountsMap(accountsMap);

            const accountOptions = R.mergeAll([
                getAccountOptionsFromResponse(authorizedAccounts),
                getAccountOptionsFromResponse(filteredOnoAccounts),
            ]);
            setAccountOptions(accountOptions);
        })();
    }, []);

    useEffect(() => {
        const newFilters = R.assocPath(
            ['Campaigns', 'options'],
            postsCampaigns,
            filters,
        );
        setFilters(newFilters);
    }, [postsCampaigns]);

    return (
        <FiltersContainer selections={filterTagsData}>
            <AllSocialMediaFilters
                filters={filters}
                setFilters={(filters: any) => setFilters(filters)}
                platformAccountsMap={platformAccountsMap}
                accountOptions={accountOptions}
                onUpdateFilters={handleFiltersUpdate}
                isPostsLoading={isDataLoading}
                currentTab={currentTab}
            />
        </FiltersContainer>
    );
};

export default AuthenticatedPostsFilters;
